var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 16.515,
    viewBox: "0 0 28 16.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_2313817",
    transform: "translate(0 -6.568)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1277",
    "data-name": "Ellipse 1277",
    cx: 2.342,
    cy: 2.342,
    r: 2.342,
    transform: "translate(2.342 8.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39813",
    "data-name": "Path 39813",
    d: "M7.81,13.468a4.907,4.907,0,0,0-1.955,3.923v.293H.878A.885.885,0,0,1,0,16.806V16.22A3.218,3.218,0,0,1,3.22,13H6.147A3.2,3.2,0,0,1,7.81,13.468Z",
    transform: "translate(0 1.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1278",
    "data-name": "Ellipse 1278",
    cx: 2.342,
    cy: 2.342,
    r: 2.342,
    transform: "translate(20.974 8.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39814",
    "data-name": "Path 39814",
    d: "M25.14,16.22v.585a.885.885,0,0,1-.878.878H19.285v-.293a4.907,4.907,0,0,0-1.955-3.923A3.2,3.2,0,0,1,18.993,13H21.92A3.218,3.218,0,0,1,25.14,16.22Z",
    transform: "translate(2.86 1.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39847",
    "data-name": "Path 39847",
    d: "M4,0A3.775,3.775,0,0,1,8,3.5,3.775,3.775,0,0,1,4,7,3.775,3.775,0,0,1,0,3.5,3.775,3.775,0,0,1,4,0Z",
    transform: "translate(10 6.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39815",
    "data-name": "Path 39815",
    d: "M16.16,14H9.72C7.944,14,6.5,17.444,6.5,19.22v1.756a.879.879,0,0,0,.878.878H18.5a.879.879,0,0,0,.878-.878V19.22C19.38,17.444,17.937,14,16.16,14Z",
    transform: "translate(1.06 1.229)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuIcon);
export default __webpack_public_path__ + "static/media/team_menu_icon.61e4dae656605dee52547617036f1751.svg";
export { ForwardRef as ReactComponent };